/**
 * Base class for CodePush packages.
 */
export class Package {
}
//# sourceMappingURL=package.js.map